import React, { FunctionComponent, useState } from 'react';

interface InformationProps {
    helpText?: string;
}

const Information: FunctionComponent<InformationProps> = ({ helpText }) => {
    const [showAboutModal, setShowAboutModal] = useState(false);
    const [showHelpModal, setShowHelpModal] = useState(false);

    return (
        <>
            <div className="show-information-button">
                <span onClick={() => setShowAboutModal(true)}>Acerca de Héroes de la Cuenca</span>|
                <span onClick={() => setShowHelpModal(true)}>Instructivo</span>
            </div>
            <div className={`information-modal  ${showAboutModal ? 'show' : 'hide'}`}>
                <h1>Acerca de Héroes de la Cuenca...</h1>
                <p>
                    El videojuego Héroes de la Cuenca se creó como una estrategia para dar a conocer algunos datos de la
                    Cuenca del Río Otún. Está dividido en tres mundos y un especial de Alta Montaña como homenaje al
                    nevado Santa Isabel ubicado entre Risaralda, Caldas y Tolima, que nutre a nuestro río Otún.
                </p>
                <h3>Créditos</h3>
                <h5>&mdash; Fotografía &mdash;</h5>
                <p>
                    Mundo Alta Montaña: IDEAM Mundo Cuenca Alta, Media y Baja: Ilda Bibiana Ramíez Mesa, Alejandro
                    Sepúlveda Quintero, Luz Adriana Gallón Uribe, Comunicaciones Alcaldía de Pereira.
                </p>
                <h5>&mdash; Voz en off &mdash;</h5>
                <p>
                    Alex Jair Monsalve Socarrás, Alejandro Sepúlveda Quintero, Paula Andrea Rendón Cardona, Luis
                    Fernando Calle Bernal.
                </p>
                <h5>&mdash; Ambientación musical &mdash;</h5>
                <p>
                    Al Ritmo de la Basura *Textos: Margarita Noreña Ortega, Ilda Bibiana Ramíez Mesa, Alejandro
                    Sepúlveda Quintero, Luz Adriana Gallón Uribe.
                </p>
                <small className="close-information" onClick={() => setShowAboutModal(false)}>
                    Regresar
                </small>
            </div>
            <div className={`information-modal  ${showHelpModal ? 'show' : 'hide'}`}>
                <h1>Instructivo</h1>
                <p>{helpText && helpText}</p>
                <small className="close-information" onClick={() => setShowHelpModal(false)}>
                    Regresar
                </small>
            </div>
        </>
    );
};

export default Information;
